import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=76bbfdd2&scoped=true&"
import script from "./ImageInfo.vue?vue&type=script&lang=tsx&"
export * from "./ImageInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./ImageInfo.vue?vue&type=style&index=0&id=76bbfdd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bbfdd2",
  null
  
)

export default component.exports